<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3>
            <i class="fas fa-map-marked-alt"></i> Módulo de Visitas
            <small style="font-size: 18px">| Registrar Deslocamento</small>
          </h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <Forms
            ref="frmGroup"
            :title="'REGISTRAR PONTO FINAL'"
            :showClearButton="true"
            :showSaveButton="true"
            :showBackButton="true"
            v-on:Clear="onClear"
            v-on:Back="onBack"
            v-on:Save="onSave"
          >
            <div class="form-group row pt-2">
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-6 mt-2">
                    <NxSelectTipoTransporte
                      @update:value="
                        handleSelectUpdate('tipoTransporteId', $event)
                      "
                    />
                  </div>
                  <div
                    v-if="hasHodometroVisitas()"
                    class="col-md-6 mt-2"
                  >
                    <label for="txtName">
                      <small class="text-danger">*</small> Hodometro Final:
                    </label>
                    <div class="input-group">
                      <span class="input-group-addon">
                        <i class="fas fa-road"> </i
                      ></span>
                      <b-form-input
                        type="number"
                        min="0"
                        :placeholder="'Digite o Km Inicial'"
                        v-model="data.hodometroFinal"
                        :required="true"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <label><small class="text-danger">*</small> Local:</label>
                <div
                  class="input-group"
                  style="border: solid 1px #d6d6d6"
                >
                  <Map
                    v-if="data.id !== null"
                    ref="map"
                    style="width: 100%; height: 400px"
                    @initialized="onInitialized"
                    @change:location="handleCoords"
                  />
                </div>
              </div>
            </div>
          </Forms>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img
            src="/static/img/bg/world_re_768g.svg"
            style="width: 40%; opacity: 0.2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import VisitasConfig from '@/shared/mixins/visitasConfig'
import { loading, toast } from '@/shared/utils/UIHelper'
import _ from 'lodash'
import Map from '../../components/Map.vue'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import { NxSelectTipoTransporte } from '@/components/nexum/components/custom-selects/index.js'

const data = {
  id: null,
  latitudeFinal: null,
  longitudeFinal: null,
  kmRodado: null,
  coordsTempoReal: null,
  tipoTransporteId: null,
  hodometroFinal: null
}

export default {
  name: 'PontoFinal',
  mixins: [ActionsForm, VisitasConfig],
  components: {
    Map,
    NxSelectTipoTransporte
  },
  data () {
    return {
      data: data,
      kmHodometroOrigin: null
    }
  },
  async mounted () {
    loading.push()
    Tools.MinimizedSidebar()
    await this.getDeslocamento()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    onInitialized () {
      loading.pop()
    },
    async handleCoords () {
      const currentCoords = await this.$refs.map.getCurrentLocation()
      const kmRodado = await this.getKmRodado(currentCoords)

      this.data.coordsTempoReal = this.data.coordsTempoReal === null
      this.data.latitudeFinal = currentCoords.latitude
      this.data.longitudeFinal = currentCoords.longitude
      this.data.kmRodado = kmRodado
    },
    async getDeslocamento () {
      const response = await DeslocamentoRepository.GetActive()

      if (response.data === '') {
        this.onBack()
        return
      }

      if (response.data.visitas && response.data.visitas.length > 0) {
        const visita = response.data.visitas.find(
          (v) => v.dataCheckOut === null
        )

        if (visita !== null && visita !== undefined) {
          this.onBack()
          return
        }
      }

      this.data.id = response.data.id
    },
    async getKmRodado (currentCoords) {
      const { data } = await DeslocamentoRepository.GetCoordinates(this.data.id)

      const origin = {
        latitude: data.latitude,
        longitude: data.longitude
      }

      const destination = {
        latitude: currentCoords.latitude,
        longitude: currentCoords.longitude
      }

      this.kmHodometroOrigin = data.hodometro

      const response = await this.$refs.map.getDistance(origin, destination)

      if (!response) {
        toast.error(
          'Não foi possível calcular a distância percorrida. Tente Novamente'
        )
        return
      }

      return response.distance.value
    },
    async onUpdate () {
      if (_.isNil(this.data.tipoTransporteId)) {
        toast.error('É necessário informar o tipo de transporte utilizado.')
        return
      }

      if (this.$refs.map.enableSearch && !this.$refs.map.search.trim()) {
        toast.error('Você precisa digitar um endereço pois selecionou Localização Manual.')
        return
      }

      if (this.data.latitudeFinal === null) {
        toast.warning(
          'Geolocalização é necessária para finalizar o deslocamento'
        )
        return
      }

      if (_.isNil(this.data.kmRodado)) {
        toast.error('Não foi possível calcular a distância percorrida.')
        return
      }

      if (this.hasHodometroVisitas() && _.isNil(this.data.hodometroFinal)) {
        toast.error('É necessário informar o hodometro final.')
        return
      }

      try {
        loading.push()
        this.data.kmRodadoPorHodometro =
          this.data.hodometroFinal - this.kmHodometroOrigin
        await DeslocamentoRepository.FinishDeslocamento(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.onBack()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    },
    retryFunction (maxAttempts, condition, action) {
      return new Promise(async (resolve, reject) => {
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          if (condition()) {
            await action()
            resolve()
            return
          }
          await new Promise((resolve) => setTimeout(resolve, 1000))

          if (attempt === maxAttempts) {
            reject(new Error())
          }
        }
      })
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.data[fieldName] = selectedValue
        return
      }

      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }

      // If to clear single select and update both types
      this.data[fieldName] = selectedValue
        ? Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
        : this.clearField(fieldName)
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/pontos/pontofinal.vue